// extracted by mini-css-extract-plugin
module.exports = {"ShopAddressSettingsModal":"shop-address-settings-modal__ShopAddressSettingsModal___2Cjff"};